module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate1"
    }
  }), _vm._v("1. Bronze gilt cuirass from Ksour es-Saf, Tunisia, "), _c('i', [_vm._v("c")]), _vm._v(". third century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BCE")]), _vm._v(". This beautifully decorated cuirass was found in a tomb in the coastal region of Carthaginian territory, south of Hadrumentum. Hellenistic in style it may have been made in Italy and could have belonged to a soldier of Hannibal’s generation.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate2"
    }
  }), _vm._v("2. The view from Eryx (modern Erice) looking west towards Drepanum (Trapani) and the Aegates Islands. The hill top position of Eryx commands the west and north-west coast of Sicily.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate3"
    }
  }), _vm._v("3. "), _c('i', [_vm._v("The Oath of Hannibal")]), _vm._v(" by Benjamin West, 1770. The scene of the oath is here imagined in the eighteenth century with romance and exoticism. The focus of the painting is the sacrificial bull and hesitancy of the young boy while the shadowy figure of a romanized Ba’al lurks above.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate4"
    }
  }), _vm._v("4. "), _c('i', [_vm._v("The Oath of Hannibal")]), _vm._v(", eighteenth-century cartoon. ‘The Bedfordshire Hannibal’ illustrates just how familiar the story of Hannibal’s oath was in the eighteenth century when contemporary politicians could be lampooned in the popular media with scenes from the general’s life.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate5"
    }
  }), _vm._v("5. Punic di-shekel showing Melqart (possibly Hamilcar) and elephant ("), _c('i', [_vm._v("c")]), _vm._v(". 237–209 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BCE")]), _vm._v("). The figure of Melqart is depicted with the Heraklean attribute of a club on the obverse and an elephant and rider on the reverse. The coin was minted in Iberia and is perhaps the most renowned of all the images associated with the Barcid family and their conquests.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate6"
    }
  }), _vm._v("6. "), _c('i', [_vm._v("Hannibal Crossing the Alps")]), _vm._v(" by Heinrich Leutemann, 1866. This hand-coloured etching captures the nineteenth-century fascination with the life of the Carthaginian general and the drama of the Alps crossing.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate7"
    }
  }), _vm._v("7. Painting by Giambattista Tiepolo, 1725–1730. This early eighteenth-century painting illustrates the moment when Hannibal recognizes his brother Hasdrubal’s head after it was catapulted into his camp following the defeat at the battle of the Metaurus (in 207 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BCE")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate8"
    }
  }), _vm._v("8. Hannibal’s head as portrayed on a monument in Gebze near Istanbul, twentieth century. The monument was commissioned by Atatürk and built after his death. Gebze is thought to be a possible location of ancient Libyssa, where Hannibal died.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/plate9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "plate9"
    }
  }), _vm._v("9. Hannibal(?) marble bust from Capua. The best-known image of Hannibal may not actually be Hannibal. The portrait was found in or near Capua and is clearly that of a helmeted military figure wearing the cloak ("), _c('i', [_vm._v("paludamentum")]), _vm._v(") of a Roman commander.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59eff632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plates.vue
// module id = 75
// module chunks = 0